import React from 'react';
import './Placeholder.css';

function PlaceHolder() {
  return <div className="lazy-comp-placeholder">...Fetching Data</div>;
}

export default PlaceHolder;
